import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDrsDeductEarningHist extends Layout {
    sourceDrsDeductHist: DataSource;
    tableDeduction: Table;
}
